import slugify from 'slugify';
import crypto from 'crypto';

// TODO: Since getSlug can be called with resolved values from labels-service which can contain HTML tags, should we consider stripping out HTML?
// Watch out for JS execution vulnerability, per https://stackoverflow.com/questions/5002111/how-to-strip-html-tags-from-string-in-javascript
/**
 * Converts a string into a valid URL slug
 *
 * Ex. 1: with arg ('Department 1') returns 'department-1'
 * Ex. 2: with arg ('Department 2') returns 'department-2'
 *
 * Uses 'slugify' as a dependency: https://github.com/simov/slugify
 *
 * @param {String} dept
 * @returns {String}
 */
export const getSlug = (dept = '') => {
	const options = { lower: true, strict: true, remove: /_/g };
	const slug = slugify(dept, options);
	return slug;
};

export const generateId = () => {
	const uuid = crypto.randomUUID().substring(2, 8); // base36 for shorter string
	return `ID_${uuid}`;
};

export const getLabelsFromItems = (items = []) =>
	items.reduce((acc, item) => {
		if (item?.label) acc.push(item.label);
		return acc;
	}, []);
